import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'ggk_layout_collapsed';

/**
 * Service to communicate layout collapse state between the event-experience shell
 * and the app-level footer. When collapsed, the event header and page footer are hidden
 * to give users more working space.
 *
 * State is persisted to localStorage so it survives tab/menu navigation.
 */
@Injectable({ providedIn: 'root' })
export class LayoutCollapseService {
  private collapsedSubject = new BehaviorSubject<boolean>(this.loadState());
  collapsed$ = this.collapsedSubject.asObservable();

  get isCollapsed(): boolean {
    return this.collapsedSubject.value;
  }

  toggle(): void {
    const next = !this.collapsedSubject.value;
    this.collapsedSubject.next(next);
    this.saveState(next);
  }

  expand(): void {
    this.collapsedSubject.next(false);
    this.saveState(false);
  }

  collapse(): void {
    this.collapsedSubject.next(true);
    this.saveState(true);
  }

  private loadState(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }

  private saveState(collapsed: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch { /* ignore */ }
  }
}
